import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "my-4 mx-auto font-semibold" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Wallet", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Activity", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Account", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tabbarItem = _resolveComponent("tabbarItem")!
  const _component_tabbar = _resolveComponent("tabbar", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_tabbar, null, {
      default: _withCtx(() => [
        _createVNode(_component_tabbarItem, { path: "/wallet" }, {
          "item-text": _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }),
        _createVNode(_component_tabbarItem, { path: "/activity" }, {
          "item-text": _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_tabbarItem, { path: "/account" }, {
          "item-text": _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}